import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Input,
  notification,
  Row,
} from 'antd'
import React, { useEffect } from 'react'
import Request from '../../../request'

const SEODrawer = props => {
  const {
    form: { getFieldDecorator, setFieldsValue, validateFields },
    visible,
    onClose,
    editData
  } = props

  useEffect(() => {
    if (editData) {
      setFieldsValue({
        path: editData.path,
        title: editData.title,
        description: editData.description,
        keywords: editData.keywords,
        pageType: editData.pageType,
        ogImage: editData.ogImage,
      })
    }
  }, [editData])

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const res = await Request.updateSEO(values)
        if (res.success) {
          notification.success({ message: res.message || 'SEO updated successfully' })
          onClose(true)
        } else {
          notification.error({ message: res.message || 'Error updating SEO' })
        }
      }
    })
  }

  return (
    <Drawer
      title={editData ? 'Edit SEO' : 'Add SEO'}
      width={720}
      onClose={() => onClose()}
      visible={visible}
      bodyStyle={{ padding: 0, paddingBottom: 80 }}
    >
      <Card bordered={false}>
        <Form layout="vertical" hideRequiredMark onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Path (e.g. /aboutUs)">
                {getFieldDecorator('path', {
                  rules: [{ required: true, message: 'Please enter the URL path' }],
                })(<Input placeholder="Enter path..." disabled={!!editData} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Meta Title">
                {getFieldDecorator('title', {
                  rules: [{ required: true, message: 'Please enter meta title' }],
                })(<Input placeholder="Enter meta title..." />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Meta Description">
                {getFieldDecorator('description', {
                  rules: [{ required: false }],
                })(
                  <Input.TextArea rows={4} placeholder="Enter meta description..." />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Meta Keywords (comma separated)">
                {getFieldDecorator('keywords', {
                  rules: [{ required: false }],
                })(<Input placeholder="Enter keywords..." />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Page Type">
                {getFieldDecorator('pageType', {
                  initialValue: 'website',
                })(<Input placeholder="e.g. website, article" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="OG Image URL">
                {getFieldDecorator('ogImage', {
                  rules: [{ required: false }],
                })(<Input placeholder="Enter image URL..." />)}
              </Form.Item>
            </Col>
          </Row>
          <div
            style={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
            }}
          >
            <Button onClick={() => onClose()} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} type="primary">
              Submit
            </Button>
          </div>
        </Form>
      </Card>
    </Drawer>
  )
}

const WrappedForm = Form.create()(SEODrawer)
export default WrappedForm
